// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  width: 100%;
  padding: 0 20%;
  position: static;
  font-size: 12px;
}
.error.absolute {
  position: absolute;
}
.error .imgWrapper {
  display: inline-block;
  margin-right: 7px;
  vertical-align: middle;
}
.error .imgWrapper img {
  float: left;
}
.error .errorBody {
  display: inline-block;
  vertical-align: middle;
  line-height: 13px;
  white-space: pre-line;
  /* Break on new lines. */
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/ErrorMessage.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AACD;AACC;EACC,kBAAA;AACF;AARA;EAWE,qBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;AAbA;EAgBG,WAAA;AAAH;AAhBA;EAqBE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EAFA,wBAAwB;AAC1B","sourcesContent":[".error {\n\twidth: 100%;\n\tpadding: 0 20%;\n\tposition: static;\n\tfont-size: 12px;\n\n\t&.absolute {\n\t\tposition: absolute;\n\t}\n\n\t.imgWrapper {\n\t\tdisplay: inline-block;\n\t\tmargin-right: 7px;\n\t\tvertical-align: middle;\n\n\t\timg {\n\t\t\tfloat: left;\n\t\t}\n\t}\n\n\t.errorBody {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\tline-height: 13px;\n\t\twhite-space: pre-line; /* Break on new lines. */\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
